import { Temperament } from './temperament';

export class EqualTemperament extends Temperament {
  // eslint-disable-next-line class-methods-use-this
  getFrequency(midi: number) {
    const baseMidi = this.temperamentBase.getMidiNumber();
    const difference = midi - baseMidi;
    return this.temperamentBaseFrequency * 2 ** (difference / 12);
  }
}
